import { connect } from 'react-redux';
import React from 'react';
import { default as Header } from 'components/Header/Header';
import { default as Pages } from 'components/Pages';
import MyHelmet from 'components/common/MyHelmet';

const App = (props) => {
	let AppClasses = ['App'];
	AppClasses.push( (props.introIsOpen || props.navIsOpen)? 'header-is-open' : 'header-is-closed' );
	AppClasses.push( (props.introIsOpen)? 'intro-is-open' : 'intro-is-closed' );
	AppClasses.push( (props.navIsOpen)? 'nav-is-open' : 'nav-is-closed' );
	AppClasses.push( (props.currentMenu)? 'has-menu-open' : 'no-menu-open' );
	AppClasses.push( 'page-' + props.paths.join('-') );
	if ( props.currentMenu ) AppClasses.push( props.currentMenu + '-menu-open' );

	// MyHelmet should precede Pages because later Helmets has higher priority
	return (
		<div id="App" className={AppClasses.join(' ')}>
			<MyHelmet />
			<Header />
			<Pages />
		</div>
	)
}

const mapStateToProps = (state) => {
	const pathSegments = (state.status.pathname)? 
		state.status.pathname.split('/').filter( val => (val !== '') ) : [];
	return {
		navIsOpen: state.menu.open,
		currentMenu: state.menu.current,
		introIsOpen: state.status.show_description,
		paths: (pathSegments.length > 0) ? pathSegments : ['home']
	}
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.jsx